// extracted by mini-css-extract-plugin
export default {"search_input":"SearchInput_search_input__FBMr4"};